const defaultBlockExplorerName = 'Block Explorer';

export default function getBlockExplorerNameByUrl(blockExplorerUrl) {
    if (!blockExplorerUrl) return defaultBlockExplorerName;
    const domainParts = blockExplorerUrl.split('/')[2]?.split('.');
    if (!domainParts || domainParts.length < 2) return defaultBlockExplorerName;
    const mainPart = domainParts[domainParts.length - 2];
    if (!mainPart) return defaultBlockExplorerName;
    if (mainPart.includes('scan')) {
        return mainPart.charAt(0).toUpperCase() +
            mainPart.slice(1).replace('scan', 'Scan');
    } else {
        return mainPart.charAt(0).toUpperCase() +
            mainPart.slice(1) + ' Explorer';
    }
}
